import { Button, Grid } from "@mui/material";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const ReportTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { label: "Job", path: "/jobreport" },
    { label: "Closed Call", path: "/Closecallreport" },
    { label: "Call Update From Mobile", path: "/Callupdationmobile" },
    { label: "Engineer Part Consumption", path: "/Engineerpartconsumption" },
    { label: "Stock In Hand", path: "/Stockinhand" },
  ];

  return (
    <Grid
      container
      spacing={1}
      sx={{
        background: "#F5F8FF",
        margin: { xs: "30px 0px 0px 0px", sm: "0px", md: "10px" },
        width: "100%",
        borderRadius: "5px",
        padding: { xs: "0px", sm: "0px", md: "10px" },
        fontWeight: 600,
        display: "flex",
        flexWrap: "nowrap",
      }}
    >
      {tabs.map((tab) => (
        <Grid item key={tab.path}>
          <Button
            variant="contained"
            size="medium"
            sx={{
              width: "100%",
              margin: "5px",
              fontWeight: "inherit",
              background:
                location.pathname === tab.path ? "#33499F" : "#D2F0F4",
              color: location.pathname === tab.path ? "#fff" : "#000000",
              "&:focus": { outline: "none" },
              "&:hover": { color: "white", background: "#33499F" },
            }}
            onClick={() => navigate(tab.path)}
          >
            {tab.label}
          </Button>
        </Grid>
      ))}
    </Grid>
  );
};

export default ReportTabs;
